<template>
  <v-layout class="text-xs-center blue-grey--text font-weight-light headline">
    <v-fade-transition mode="out-in">
      <!-- A message to show when there is no classification -->
      <v-flex
        v-if="!classification"
        key="no-classification"
      >Selecciona una clasificación para ver sus productos</v-flex>
      <!-- A spinner to show when the products are in loading state -->
      <v-flex v-else-if="loadingProducts" key="loading-products">
        <v-pulse-loader :loading="loadingProducts" />
      </v-flex>
      <!-- A message to show when there are no products -->
      <v-flex
        v-else-if="!products.length"
        :key="classification.name"
      >La clasificación "{{ classification.name }}" no tiene productos.</v-flex>
      <!-- A message when there is no filtered product -->
      <v-flex
        v-else-if="!filteredProducts.length"
        key="no-filtered-products"
      >Ningún producto contiene "{{ searchInput }}"</v-flex>
    </v-fade-transition>
  </v-layout>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import VPulseLoader from "vue-spinner/src/PulseLoader";

export default {
  components: {
    VPulseLoader
  },
  computed: {
    ...mapGetters("ner", ["filteredProducts"]),
    ...mapState("ner", [
      "classification",
      "products",
      "loadingProducts",
      "searchInput"
    ])
  }
};
</script>